// extracted by mini-css-extract-plugin
export default {"priceTD":"ContentBox_priceTD__8RpsR","table":"ContentBox_table__p1Dpd"};